import { useEffect, useState } from 'react';

/**
 * true mientras la consulta de medios se cumple (p. ej. '(max-width: 599px)'); se actualiza al girar o cambiar el
 * tamaño de la ventana.
 * @param {string} consulta
 * @returns {boolean}
 */
export default function useMedia(consulta) {
  const [cumple, setCumple] = useState(() => window.matchMedia(consulta).matches);
  useEffect(() => {
    const mq = window.matchMedia(consulta);
    const cambio = () => setCumple(mq.matches);
    cambio();
    mq.addEventListener('change', cambio);
    return () => mq.removeEventListener('change', cambio);
  }, [consulta]);
  return cumple;
}
